import request from '@/utils/request';

export function getNoticeList(params: any) {
  return request({
    url: 'notice/noticeList',
    method: 'get',
    params
  });
}
export function getNoticeDetail(params: any) {
  return request({
    url: 'notice/notice',
    method: 'get',
    params
  });
}
export function delNotice(data: any) {
  return request({
    url: 'notice/notice',
    method: 'DELETE',
    data
  });
}
export function addNotice(data: any) {
  return request({
    url: 'notice/notice',
    method: 'post',
    data
  });
}
